export const APP_URL = process.env.APP_URL
export const API_URL = process.env.API_URL
